/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { IMAGE_TYPE_API_MAP, TImageType } from "./TImageType";

const DEFAULT_WIDTH: number = 662;
const DEFAULT_HEIGHT: number = 372;
const IMAGE_PATH: string = "/images";

/**
 * Builds the poster image URL for a tile by constructing the image-host
 * service request URL with the appropriate query parameters.
 *
 * @param baseUrl   - Base URL from servicesBaseUrls["image-host"]
 *                    (e.g. "https://imagegenerator.staging.prod.tivoservice.com")
 * @param objectId  - The content's digObjectId (e.g. "tivo:co123456", "tivo:ct789012")
 * @param imageType - One of the supported TImageType values
 * @param width     - Image width in pixels (default: 662)
 * @param height    - Image height in pixels (default: 372)
 * @returns         Fully-qualified image URL string
 */
export const buildPosterImageUrl = (
  baseUrl: string,
  objectId: string,
  imageType: TImageType,
  width: number = DEFAULT_WIDTH,
  height: number = DEFAULT_HEIGHT
): string => {
  const normalizedBase: string = baseUrl.endsWith("/")
    ? baseUrl.slice(0, -1)
    : baseUrl;

  const params: URLSearchParams = new URLSearchParams({
    objectid: objectId,
    imagetype: IMAGE_TYPE_API_MAP[imageType],
    width: String(width),
    height: String(height)
  });

  return normalizedBase + IMAGE_PATH + "?" + params.toString();
};
